function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as o } from "./index.es33.js";
import { clsx as R } from "./index.es105.js";
import { InputHint as X } from "./index.es108.js";
import { inputSelectors as Y } from "./index.es107.js";
import { Typography as Z } from "./index.es35.js";
import "./index.es36.js";
import { RangeDatePicker as ee } from "./index.es82.js";
import { CalendarIcon as oe } from "./index.es642.js";
import { sortDate as te, formatDate as ne, getNormalizedDate as W } from "./index.es643.js";
import { getPopupPosition as re } from "./index.es644.js";
import { preserveTimeDateRangeSelect as se } from "./index.es645.js";
import { RangePlaceholder as ae } from "./index.es646.js";
import { CalendarPosition as K, InputPickerSize as k } from "./index.es434.js";
import { useRangeRef as pe } from "./index.es647.js";
import { useRangeState as le } from "./index.es648.js";
import { useChangeInput as ie } from "./index.es649.js";
import { useClosePopup as me } from "./index.es650.js";
import { PickerWrapper as ue } from "./index.es651.js";
import { DATE_MASK_SINGLE_REG as ce } from "./index.es652.js";
import t from "./index.es653.js";
import h from "./index.es111.js";
var fe = function fe(_ref) {
  var z = _ref.label,
    E = _ref.placeholder,
    v = _ref.isError,
    j = _ref.hint,
    y = _ref.isDayDisabled,
    n = _ref.dates,
    w = _ref.isClearable,
    T = _ref.onSelect,
    r = _ref.isDisabled,
    _ref$calendarPosition = _ref.calendarPosition,
    V = _ref$calendarPosition === void 0 ? K.default : _ref$calendarPosition,
    _ref$size = _ref.size,
    P = _ref$size === void 0 ? k.default : _ref$size;
  var _pe = pe(),
    i = _pe.inputRef,
    C = _pe.wrapperRef,
    m = se(n, T),
    _le = le(n, i),
    s = _le.from,
    a = _le.to,
    N = _le.setInputValue,
    p = _le.selectedDates,
    x = _le.setSelectedDates,
    u = _le.isFocused,
    c = _le.setIsFocused,
    l = _le.isOpen,
    I = _le.setIsOpen,
    F = _le.hoveredDate,
    A = _le.setHoveredDate,
    H = _le.onClear,
    f = _le.inputValue,
    M = re(V, P, !!(j !== null && j !== void 0 && j.length)),
    _ = ie({
      setInputValue: N,
      stateValues: [s, a],
      inputRef: i
    }),
    _me = me({
      from: s,
      to: a,
      inputRef: i,
      setIsOpen: I,
      wrapperRef: C
    }),
    G = _me.onInputKeyDown,
    O = _me.onWrapperKeyDown,
    b = _me.onBlur,
    q = function q() {
      return n && (m === null || m === void 0 ? void 0 : m(void 0));
    },
    L = function L() {
      (n || s || a) && w ? (H(), q()) : (I(!l), c(!u));
    },
    $ = function $(e) {
      if (e[0] && e[1]) {
        m !== null && m !== void 0 && m(e), x([null, null]), requestAnimationFrame(function () {
          return c(!1);
        });
        return;
      }
      p[0] && e[0] && !e[1] && m !== null && m !== void 0 && m(te(p[0], e[0])), e[0] && (N("".concat(ne(e[0]), " \u2014 ")), x([e[0], null]));
    },
    J = function J() {
      if (I(!1), c(!1), !f) return;
      var _f$split = f.split(" — "),
        _f$split2 = _slicedToArray(_f$split, 2),
        e = _f$split2[0],
        S = _f$split2[1],
        Q = [e, S].some(function (D) {
          return !ce.test(D);
        }),
        d = e ? W(e) : null,
        g = S ? W(S) : null,
        U = [d, g].some(function (D) {
          return !D || (y === null || y === void 0 ? void 0 : y(D));
        }),
        B = Q || U || !g || !d || g < d;
      B && x([null, null]), m(B ? void 0 : [d, g]);
    };
  return o.jsxs("div", {
    ref: C,
    className: t.wrapper,
    onBlur: b,
    onKeyDown: O,
    children: [o.jsxs(ue, {
      label: z,
      isDisabled: r,
      isError: v,
      children: [o.jsxs("div", {
        className: R(h.wrapper, t.inputInner, Y.classNames.wrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, h.wrapperWithError, v), h.largeSizeWrapper, P === k.large), t.inputInnerFocused, u || l), t.inputInnerWithValue, !!(s || a))),
        "data-focused": u || l,
        children: [o.jsx(ae, {
          selectedDates: p,
          hoveredDate: F,
          isFocused: u,
          isOpen: l,
          inputValue: f,
          placeholder: E,
          isDisabled: r
        }), o.jsx(Z.Body2, {
          className: R(h.input, t.rangeInput),
          ref: i,
          as: "input",
          disabled: r,
          type: "text",
          value: f,
          onChange: function onChange(e) {
            return _(e.target.value);
          },
          onFocus: function onFocus() {
            return c(!0);
          },
          onBlur: J,
          onKeyDown: G
        }), o.jsx("button", {
          className: t.button,
          disabled: r,
          type: "button",
          onClick: L,
          onMouseDown: function onMouseDown(e) {
            return e.preventDefault();
          },
          children: o.jsx(oe, {
            value: n || s || a,
            isClearable: w
          })
        })]
      }), o.jsx(X, {
        isError: v,
        hint: j
      })]
    }), l && !r && o.jsx("div", {
      className: R(t.datePickerWrapper, M),
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      children: o.jsx(ee, {
        isDayDisabled: y,
        dates: p[0] ? [p[0], F] : n,
        onSelect: $,
        onHover: A
      })
    })]
  });
};
fe.CalendarPosition = K;
export { fe as Range };